<div mat-dialog-content *ngIf="{ allNotes: allNotes$ | async, currentUser: currentUser$ | async } as data">
  <h1>Notes</h1>
  <div class="flex place-content-center place-items-center">
    <mat-button-toggle-group class="button-group" #group="matButtonToggleGroup">
      <mat-button-toggle fxFlex="dialogData.appointmentId? '33' : '50'" *ngIf="dialogData.associateId" value="customer"
        checked>
        <div class='flex flex-row justify-center items-center'>
          <span *ngIf="data.allNotes.customerNotes && data.allNotes.customerNotes?.notes?.split('\r').length > 0"
            class="mr-2 w-2 h-2 rounded-full bg-blue-500" style="z-index: 4;">
          </span>
          Customer
        </div>
      </mat-button-toggle>
      <mat-button-toggle fxFlex="dialogData.appointmentId? '33' : '50'" *ngIf="dialogData.vehicleId" value="vehicle">
        <div class='flex flex-row justify-center items-center'>
          <span *ngIf="data.allNotes.vehicleNotes && data.allNotes.vehicleNotes?.notes?.split('\r').length > 0"
            class="mr-2 w-2 h-2 rounded-full bg-blue-500" style="z-index: 4;">
          </span>
          Vehicle
        </div>
      </mat-button-toggle>
      <mat-button-toggle *ngIf="dialogData.appointmentId" fxFlex="33" value="appointment">
        <div class='flex flex-row justify-center items-center'>
          <span *ngIf="data.allNotes.appointmentNotes && data.allNotes.appointmentNotes?.notes?.split('\r').length > 0"
            class="mr-2 w-2 h-2 rounded-full bg-blue-500" style="z-index: 4;">
          </span>
          Appointment
        </div>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <ng-container [ngSwitch]="group.value">
    <div *ngSwitchCase="'vehicle'">
      <div class="flex flex-col" *ngIf="data.allNotes.vehicleNotes">
        <p class="mat-body-1" *ngFor="let note of data.allNotes.vehicleNotes?.notes?.split('\r\n')">{{note}}</p>
      </div>
      <form class="flex flex-col place-content-start place-items-center w-full" [formGroup]="vehicleNoteForm">
        <mat-form-field class="w-full">
          <textarea cdkFocusInitial cdkTextareaAutosize name="vehicleNote" autocomplete="false" rows="4" matInput
            placeholder="Enter vehicle note" formControlName="vehicleNote"></textarea>
        </mat-form-field>
        <div class="flex place-content-center place-items-center w-full">
          <button mat-flat-button color="primary" [disabled]="disableAddButton || vehicleNoteForm.invalid"
            (click)="AddVehicleNote(vehicleNoteForm.get('vehicleNote').value, data.allNotes.vehicleNotes, data.currentUser, dialogData.vehicleId)"
            data-cy="add-vehicle-note-button">Add
          </button>
        </div>
      </form>
    </div>

    <div *ngSwitchCase="'customer'">
      <div class="flex flex-col" *ngIf="data.allNotes.customerNotes">
        <p class="mat-body-1" *ngFor="let note of data.allNotes.customerNotes?.notes?.split('\r\n')">{{note}}</p>
      </div>
      <form class="flex flex-col place-content-start place-items-center w-full" [formGroup]="customerNoteForm">
        <mat-form-field class="w-full">
          <textarea cdkFocusInitial cdkTextareaAutosize name="customerNote" autocomplete="false" rows="4" matInput
            placeholder="Enter customer note" formControlName="customerNote"></textarea>
        </mat-form-field>
        <div class="flex place-content-center place-items-center w-full">
          <button mat-flat-button color="primary" [disabled]="disableAddButton || customerNoteForm.invalid"
            (click)="AddCustomerNote(customerNoteForm.get('customerNote').value, data.allNotes.customerNotes, data.currentUser, dialogData.associateId)"
            data-cy="add-customer-note-button">Add
          </button>
        </div>
      </form>
    </div>

    <div *ngSwitchCase="'appointment'">
      <div class="flex flex-col" *ngIf="data.allNotes.appointmentNotes">
        <p class="mat-body-1" *ngFor="let note of data.allNotes.appointmentNotes?.notes?.split('\r\n')">{{note}}</p>
      </div>
      <form class="flex flex-col place-content-start place-items-center w-full" [formGroup]="appointmentNoteForm">
        <mat-form-field class="w-full">
          <textarea cdkFocusInitial cdkTextareaAutosize name="appointmentNote" autocomplete="false" rows="4" matInput
            placeholder="Enter appointment note" formControlName="appointmentNote"></textarea>
        </mat-form-field>


        <div class="place-content-center place-items-center">
          <button mat-flat-button color="primary" [disabled]="disableAddButton || appointmentNoteForm.invalid"
            (click)="AddAppointmentNote(appointmentNoteForm.get('appointmentNote').value, data.allNotes.appointmentNotes, data.currentUser, dialogData.appointmentId)"
            data-cy="add-appointment-note-button">Add
          </button>
        </div>
      </form>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions class="place-content-end justify-end">
  <button mat-button mat-dialog-close='false' cdkFocusInitial>Close</button>
</div>